<script setup lang="ts">
import LeIconButton from "@dsk/components/IconButton/LeIconButton.vue";
import LeTooltip from "@dsk/components/LeTooltip.vue";
import LeFile from "@dsk/icons/LeFile.vue";
import { computed } from "vue";

import type { DictsysInflectionScheme, DictsysWordclass } from "@/types";

import LeArticleInflectionSchemeButtonProvider from "./LeArticleInflectionSchemeButtonProvider.vue";

const props = defineProps<{
  language: string;
  headWord: string;
  wordclass: DictsysWordclass;
  inflectionScheme: DictsysInflectionScheme;
  schemeId: string;
  usageLanguage: string;
}>();

const tooltipText = computed<string>(() =>
  props.usageLanguage === "da" ? "Se bøjningsskema" : "Flexionstabelle zeigen"
);
</script>

<template>
  <LeArticleInflectionSchemeButtonProvider v-slot="{ isOpen, toggle }" v-bind="props">
    <LeTooltip :text="tooltipText" :margin-bottom="10" v-bind="$attrs">
      <div class="le-article-inline-inflection-scheme-button">
        <LeIconButton
          class="le-article-inline-inflection-scheme-button__button"
          :aria-pressed="isOpen"
          aria-label="Bøjningsskema"
          @click="toggle()"
        >
          <LeFile role="presentation" />
        </LeIconButton>
      </div>
    </LeTooltip>
  </LeArticleInflectionSchemeButtonProvider>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-article-inline-inflection-scheme-button {
  display: inline-block;
  position: relative;
  width: 28px;
  height: 18px;

  &__button {
    position: absolute;
    top: -3px;
  }
}
</style>
